/**
 * 分配类型列表组件
 * 用于显示和选择用户分配类型
 */
import React from 'react';
import { Radio, Space, Tag } from 'antd';
import { useUserAssignmentStore } from './useUserAssignmentStore';
import { ASSIGNMENT_TYPE_CONFIG, ASSIGNMENT_TYPES } from './constants';

const AssignmentTypeList = () => {
  // 直接从store获取状态和方法
  const selectedType = useUserAssignmentStore(state => state.selectedType)
  const setSelectedType = useUserAssignmentStore(state => state.setSelectedType)
  return (
    <div className="overflow-y-auto" style={{ height: 'calc(70vh - 60px)' }}>
      <Radio.Group
        value={selectedType}
        onChange={(e) => setSelectedType(e.target.value)}
        className="w-full"
      >
        <Space direction="vertical" size={12} className="w-full">
          {Object.values(ASSIGNMENT_TYPES).map((type) => {
            const config = ASSIGNMENT_TYPE_CONFIG[type];
            const isSelected = selectedType === type;
            
            return (
              <Radio
                key={type}
                value={type}
                className="w-full p-3 rounded-lg m-0 flex items-start"
                style={{
                  border: isSelected ? `2px solid ${config.color}` : '1px solid #d9d9d9',
                  backgroundColor: isSelected ? `${config.color}08` : '#fafafa'
                }}
              >
                <div className="ml-2 flex-1">
                  <div className={`flex items-center mb-1 ${
                    isSelected ? 'font-bold' : 'font-normal'
                  }`}>
                    {config.icon}
                    <span className="ml-2">{config.label}</span>
                    <Tag 
                      color={config.isDynamic ? 'orange' : 'blue'} 
                      size="small" 
                      className="ml-2"
                    >
                      {config.isDynamic ? '动态' : '静态'}
                    </Tag>
                  </div>
                  <div className="text-xs text-gray-600 leading-relaxed">
                    {config.description}
                  </div>
                </div>
              </Radio>
            );
          })}
        </Space>
      </Radio.Group>
    </div>
  );
};

export default AssignmentTypeList;